export const state = {
  packageVersion: process.env.VUE_APP_VERSION || '0',
  env: process.env.NODE_ENV
}

export const getters = {
  appVersion: state => {
    return state.packageVersion
  },
  environment: state => {
    return state.env
  }
}
